import React from 'react';
import './option-layout.scss';
import { useTranslation } from 'react-i18next';
import entityIcons, { categoryAccent } from './entityIcons';
import { ShieldAlert } from 'lucide-react';

const OptionLayout = ({
	record,
	title,
	category,
}) => {
	const { t } = useTranslation();
	const Icon = entityIcons[record?.key] || ShieldAlert;
	const accent = categoryAccent[category] || 'default';

	return (
		<span className="layout-item-wrapper">
			<div
				className="layout-item"
				title={t(record.description) || record.description}
			>
				<span className={`box-icon-chip box-icon-chip--${accent}`} aria-hidden="true">
					<Icon className="box-icon-svg" strokeWidth={1.75} />
				</span>
				<span>{title}</span>
			</div>
		</span>
	);
};

export default OptionLayout;
